import {
  Brush,
  Flame,
  Flower2,
  Gift,
  Hand,
  HandHeart,
  Layers,
  Palette,
  Scissors,
  Sparkles,
  Sun,
  Wind,
} from 'lucide-react'

/** @type {Record<string, import('lucide-react').LucideIcon>} */
const ICON_BY_NAME = {
  threading: Scissors,
  facial: Sparkles,
  bleach: Sun,
  'mani - pedi combos': Hand,
  'gel polish': Palette,
  'mani - pedi': Hand,
  'hair styling': Wind,
  'hair care/treatments': Sparkles,
  'hair extensions': Layers,
  'hair colour (shoulder length, ++ based on length)': Palette,
  waxing: Flame,
  massage: HandHeart,
  'make up': Brush,
  'kids pampering package': Gift,
  henna: Flower2,
  'nail extensions': Hand,
}

/** @type {Array<{ pattern: RegExp, icon: import('lucide-react').LucideIcon }>} */
const ICON_BY_KEYWORD = [
  { pattern: /thread/i, icon: Scissors },
  { pattern: /facial|skin/i, icon: Sparkles },
  { pattern: /bleach/i, icon: Sun },
  { pattern: /mani|pedi|nail/i, icon: Hand },
  { pattern: /gel polish/i, icon: Palette },
  { pattern: /hair styl|blow|cut/i, icon: Wind },
  { pattern: /hair care|treatment|spa|kerat|botox|protein/i, icon: Sparkles },
  { pattern: /extension/i, icon: Layers },
  { pattern: /colour|color|henna/i, icon: Palette },
  { pattern: /wax/i, icon: Flame },
  { pattern: /massage|polish/i, icon: HandHeart },
  { pattern: /make\s*up|makeup/i, icon: Brush },
  { pattern: /kid|child/i, icon: Gift },
]

/**
 * @param {string} name
 */
export function normalizeCategoryName(name) {
  return name.trim().toLowerCase()
}

/**
 * @param {Pick<import('@/types/api').ServiceCategory, 'name'>} category
 * @returns {import('lucide-react').LucideIcon}
 */
export function resolveCategoryIcon(category) {
  const key = normalizeCategoryName(category.name)

  if (ICON_BY_NAME[key]) {
    return ICON_BY_NAME[key]
  }

  for (const { pattern, icon } of ICON_BY_KEYWORD) {
    if (pattern.test(category.name)) {
      return icon
    }
  }

  return Layers
}
